export const generateWasmLink = (serviceId: string) => {
  return `https://excel.uat.us.coherent.global/agilno/api/v3/nodegen/public/getnodegenzipbyId/service/${serviceId}`
}

